import { createContext, useContext, useReducer } from "react";
import Storage from "@/utils/store";

const initialInfo: InitialInfo = {
  openModal: false,
  loginInfo: undefined,
  curUserInfo: undefined,
  curUserProductAllList: undefined,
  productGroupDict: Storage.l.get("productGroupDict"), // 不需要清空
  serviceMenuItems: undefined,
  isPhoneLogin: false,
  tempJwt: undefined,
};

const UserInfoContext = createContext<InitialInfo>({});
const UserInfoDispatchContext = createContext<any>(null);

const useUserInfo = () => {
  return useContext(UserInfoContext);
};

const useUserInfoDispath = () => {
  return useContext(UserInfoDispatchContext);
};

function userInfoReducer(state: InitialInfo, action: any) {
  switch (action.type) {
    case "login/open":
      return {
        ...state,
        openModal: true,
      };
    case "login/close":
      return {
        ...state,
        openModal: false,
      };
    case "login/quit":
      return {
        ...initialInfo,
      };
    case "user/setProductGroupDict":
      return {
        ...state,
        productGroupDict: action.data,
      };
    case "user/setUserInfo":
      return {
        ...state,
        loginInfo: action.loginInfo,
        curUserInfo: action.curUserInfo,
      };
    case "user/seUserProduct":
      return {
        ...state,
        curUserProductAllList: action.data,
      };
    case "user/setMenuList":
      return {
        ...state,
        serviceMenuItems: action.data,
      };
    case "user/setIsPhoneLogin":
      return {
        ...state,
        isPhoneLogin: action.data
      }
    case "user/setTempJwt":
      return {
        ...state,
        tempJwt: action.data,
      };
    case "user/clearTempJwt":
      return {
        ...state,
        tempJwt: undefined,
      }  
    default:
      return {
        ...state,
      };
  }
}

const LoginProvider = ({ children }: { children: React.ReactElement }) => {
  const _initialInfo = {
    ...initialInfo,
    loginInfo: Storage.l.get("loginInfo"),
    curUserInfo: Storage.l.get("curUserInfo"),
    serviceMenuItems: Storage.l.get("serviceMenuItems"),
  };
  const [userInfo, dispatch] = useReducer(userInfoReducer, _initialInfo);

  return (
    <UserInfoContext.Provider value={userInfo}>
      <UserInfoDispatchContext.Provider value={dispatch}>
        {children}
      </UserInfoDispatchContext.Provider>
    </UserInfoContext.Provider>
  );
};

export default LoginProvider;

export { useUserInfo, useUserInfoDispath };
